<template>
  <div class="SheetsRow">
    <Row class="createSpreadsheet">
      <Column :md="9">
        <Field
          :canCopy="true"
          disabled
          :label="$t('spreadsheet')"
          :value="spreadsheetUrl"
          @update:value="$up('spreadsheetUrl', $event)" />
      </Column>
      <Column :md="3">
        <Btn
          class="success"
          :isLoading="isCreatingSpreadsheet"
          @click="$emit('create')">
          {{ spreadsheetUrl ? $t('updateSpreadsheet') : $t('createSpreadsheet') }}
        </Btn>
      </Column>
    </Row>
  </div>
</template>

<script>
export default {
  props: {
    isCreatingSpreadsheet: Boolean,
    spreadsheetUrl: String,
  },
}
</script>

<style lang="scss">
.SheetsRow {
  align-items: end;

  > .Column {
    margin: 0.5rem 0;

    > .Field-cont {
      margin-bottom: 0;
    }
  }

  .Btn {
    margin-top: 2.5rem;
  }
}
</style>

<i18n>
{
  "en": {
    "createSpreadsheet": "Create spreadsheet",
    "updateSpreadsheet": "Update spreadsheet",
    "spreadsheet": "Laptops spreadsheet"
  }
}
</i18n>
